module.exports = __webpack_public_path__ + "img/89b540b.jpg";